// ── Welle B1: Push-Link → Stelle in der App ───────────────────────────────────
// Links kommen aus server/lib/push-erinnerungen.js (pushLink: „/?ziel=…&…“). Ältere
// Benachrichtigungen tragen noch Pfade (/mails, /mdl-luecken …) — auch die lösen auf.
// Alles Unbekannte (auch /schulrecht) führt auf Heute. Rein, ohne Seiteneffekte:
// server/scripts/test-push-ziele.js prüft die Zuordnung Push-Art → Bildschirm.
import type { ProfilZiel } from '../types';

export type PushZiel =
  | { art: 'heute'; noteVorschlaege: boolean }
  | { art: 'schueler'; schuelerId: number; bereich: ProfilZiel | null }
  | { art: 'klasse'; klasseId: number | null }
  | { art: 'aktion'; klasseId: number | null; aktionId: number | null }
  | { art: 'fehlzeiten'; klasseId: number | null }
  | { art: 'beitrag'; beitragId: number };   // Welle A3: Beitrag in „Sicherheit & Tipps“

const BEREICHE: ProfilZiel[] = ['ueberblick', 'noten', 'fehlzeiten', 'mitarbeit', 'gespraeche', 'eltern'];
const HEUTE: PushZiel = { art: 'heute', noteVorschlaege: false };

function id(wert: string | null): number | null {
  const n = Number(wert);
  return wert && Number.isInteger(n) && n > 0 ? n : null;
}

export function pushZiel(link: string): PushZiel {
  let u: URL;
  try { u = new URL(link, 'http://app.invalid'); } catch { return HEUTE; }
  const q = u.searchParams;
  const pfad = u.pathname.replace(/\/+$/, '') || '/';

  if (pfad === '/') {
    switch (q.get('ziel')) {
      case 'schueler': {
        const s = id(q.get('id'));
        const b = q.get('bereich') as ProfilZiel | null;
        return s ? { art: 'schueler', schuelerId: s, bereich: b && BEREICHE.includes(b) ? b : null } : HEUTE;
      }
      case 'klasse': {
        const k = id(q.get('klasse'));
        return k ? { art: 'klasse', klasseId: k } : HEUTE;
      }
      case 'aktion': {
        const k = id(q.get('klasse'));
        return k ? { art: 'aktion', klasseId: k, aktionId: id(q.get('aktion')) } : HEUTE;
      }
      case 'fehlzeiten': return { art: 'fehlzeiten', klasseId: id(q.get('klasse')) };
      case 'note-vorschlaege': return { art: 'heute', noteVorschlaege: true };
      case 'beitrag': {
        const b = id(q.get('id'));
        return b ? { art: 'beitrag', beitragId: b } : HEUTE;
      }
      default: return HEUTE;
    }
  }

  // Pfade älterer Benachrichtigungen (vor Welle B1) — ohne IDs, daher die nächstbeste Stelle
  switch (pfad) {
    case '/fehlzeiten':
    case '/mails':           return { art: 'fehlzeiten', klasseId: null };
    case '/aktionen':        return { art: 'aktion', klasseId: null, aktionId: null };
    case '/schuelerprofil':
    case '/mdl-luecken':     return { art: 'klasse', klasseId: null };
    case '/mdl-vorschlaege': return { art: 'heute', noteVorschlaege: true };
    default:                 return HEUTE;
  }
}

// Welle B2: Adresse nach dem Kaltstart — nur die Push-Parameter fallen weg (ziel und seine
// Werte), alle anderen bleiben (z. B. ?gmail=connected nach der Gmail-Verbindung).
const PUSH_PARAMETER = ['ziel', 'id', 'klasse', 'aktion', 'bereich'];
export function ohnePushParameter(pfad: string, suche: string): string {
  const q = new URLSearchParams(suche);
  if (q.has('ziel')) for (const p of PUSH_PARAMETER) q.delete(p);
  const rest = q.toString();
  return `/${rest ? `?${rest}` : ''}`;
}

// Kaltstart: trägt die Startadresse ein Push-Ziel? (Wurzel ohne ziel bzw. die
// öffentlichen Rechtsseiten zählen nicht.)
export function istPushStart(pfad: string, suche: string): boolean {
  return (pfad === '/' || pfad === '') ? new URLSearchParams(suche).has('ziel') : true;
}
